import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab
} from '@mui/material';
import ShopProductGrid from '../components/shop/ShopProductGrid';
import CartTab from '../components/shop/CartTab';
import PendingDeliveryTab from '../components/shop/PendingDeliveryTab';
import ShopOrderHistory from '../components/shop/ShopOrderHistory';

const Shop = () => {
  const [currentTab, setCurrentTab] = useState(0);

  // Load cart data when shop page loads
  useEffect(() => {
    const loadCart = () => {
      try {
        const companyId = localStorage.getItem('companyId');
        console.log('🛒 Shop - Tentativo di caricamento carrello per azienda:', companyId);
        
        if (!companyId) {
          console.error('Shop - ID azienda mancante, impossibile caricare il carrello');
          return;
        }
        
        const savedCart = localStorage.getItem(`shopCart_${companyId}`);
        console.log('🛒 Shop - Carrello salvato trovato:', savedCart ? 'Sì' : 'No');
        
        if (!savedCart) {
          console.log('🛒 Shop - Nessun carrello trovato nel localStorage');
          return;
        }

        // Parse and validate cart data
        const cartData = JSON.parse(savedCart);
        if (!Array.isArray(cartData)) {
          console.error('Shop - Formato carrello non valido');
          return;
        }

        console.log('🛒 Shop - Carrello caricato con successo:', cartData.length, 'articoli');
      } catch (err) {
        console.error('Shop - Errore nel caricamento del carrello:', err);
      }
    };

    loadCart();
  }, []);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Box sx={{ width: '98%', mx: 'auto', py: 2 }}>
      <Typography variant="h4" gutterBottom>
        Shop B2B
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs 
          value={currentTab} 
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab label="CATALOGO PRODOTTI" />
          <Tab label="CARRELLO" />
          <Tab label="ARTICOLI DA RICEVERE" />
          <Tab label="STORICO ORDINI" />
        </Tabs>
      </Box>

      <Box sx={{ mt: 2 }}>
        {currentTab === 0 && <ShopProductGrid />}
        {currentTab === 1 && <CartTab />}
        {currentTab === 2 && <PendingDeliveryTab />}
        {currentTab === 3 && <ShopOrderHistory />}
      </Box>
    </Box>
  );
};

export default Shop;